<template>
  <div class="container" v-if="isShow">
    <div class="vote">
      <span class="icontemp stemp-close" @click="close"></span>
      <iframe frameborder="0" :src="src"></iframe>
    </div>
  </div>
</template>

<script>
import { buildVoteData, buildVoteMethod, mounted } from "../../common/vote";
export default {
  name: "Vote",
  data() {
    return buildVoteData({
      type: "pc"
    });
  },
  created() {
    let self = this;
    mounted(self);
  },
  methods: buildVoteMethod({})
};
</script>

<style scoped></style>
